<div
  #mapDiv
  id="map"
  [style.height.px]="height"></div>
